import { Controller } from 'stimulus'
import CableReady     from 'cable_ready'
import consumer       from 'channels/consumer'

export default class extends Controller {

  static targets = ['message', 'filesGrid', 'adminOnly']

  // ACTION CABLE INITIALISATION
  initialize() {
    const chat_id  = this.data.get("chatId")
    const channel  = this.data.get("channel")
    this.setOwners = this.setOwners.bind(this)
    this.received  = this.received.bind(this)
    this.params    = { channel, chat_id }
  }

  connect() {
    this.setOwners()
    this.scrollToLatest()
    this.subscription = consumer.subscriptions.create(this.params, { received: this.received })
  }

  disconnect() {
    this.subscription.unsubscribe()
  }

  received(data) {
    if (data.cableReady) CableReady.perform(data.operations)

    this.setOwners()
    this.scrollToLatest()
  }

  setOwners() {
    const currentUser = this.data.get("user")
    const admin       = this.data.get("admin")

    this.messageTargets.forEach(message => {
      if (message.dataset.author == currentUser) message.classList.add("owned")
    })

    this.filesGridTargets.forEach(filesGrid => {
      filesGrid.style.direction = filesGrid.dataset.author == currentUser ? 'rtl' : 'ltr'
    })

    if (admin === "true") {
      this.adminOnlyTargets.forEach(adminOnly => {
        adminOnly.classList.remove("d-none")
      })
    }
  }

  // Scroll the list itself: scrollIntoView would drag the page along with it.
  scrollToLatest() {
    const messages = this.element.querySelector('.logs__messages')
    if (!messages) return

    const toBottom = () => { messages.scrollTop = messages.scrollHeight }

    toBottom()
    requestAnimationFrame(toBottom)

    // A picture only claims its height once loaded, pushing the last message out.
    messages.querySelectorAll('img').forEach(image => {
      if (image.complete) return

      image.addEventListener('load',  toBottom, { once: true })
      image.addEventListener('error', toBottom, { once: true })
    })
  }
}
